import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/saas-video/saas_banner.webp";
import { Link } from "gatsby";
import Video from "../../images/services-usa/saas-video/banner_video.mp4";

function Banner() {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <section
      className="banner_sass text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      {/* <div className="home_vid">
        <video muted loop autoPlay id="myVideo" playsInline>
          <source src={Video} type="video/mp4" />
        </video>
      </div> */}
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banner_content">
              <span>Dedicated SaaS Video Production for Tech Brands</span>
              <h1>Best B2B SaaS Video Production Services in USA</h1>
              <p>
                We produce thought-provoking SaaS explainer videos that are
                engaging, and creative in selling your SaaS to the world with a
                powerful story.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get a Quote
              </Link>
              <button
                className="border_btn saas_banner_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
